import Vue from "vue"

import resetMixin from "~/mixins/store/resetToInitialState"

const initialState = function () {
  return {
    id: 0,
    band: 0,
    messages: {},
    influencers: [],
    goals: [],
    past_message_step: false,
    past_recap_step: false,
    past_sendtrack_step: false,
    past_selection_step: false,
  }
}

export const state = initialState

export const mutations = {
  SET: function (state, patch) {
    const ignoreKeys = ["track", "promo", "pricing"]
    const id = state.id || patch.id
    const boolean_checks = [
      "past_sendtrack_step",
      "past_selection_step",
      "past_message_step",
      "past_recap_step",
    ]

    boolean_checks.forEach((key) => {
      const raw_value = this.$cookies.get(`${key}_${id}`)

      if (typeof patch[key] !== "boolean") {
        try {
          patch[key] =
            typeof raw_value === "string" ? JSON.parse(raw_value) : state[key]
        } catch {
          this.$cookies.remove(`${key}_${id}`)
        }
      }
    })
    for (let key in patch) {
      if (typeof patch[key] === typeof state[key] && !ignoreKeys.includes(key))
        Vue.set(state, key, patch[key])
    }
    boolean_checks.forEach((key) => {
      /*
       * one week lifetime
       */
      this.$cookies.set(`${key}_${id}`, patch[key], {
        maxAge: 60 * 60 * 24 * 7,
        path: "/",
      })
    })
  },
  ADD_INFLUENCER_ARRAY: function (state, influencer_id_array) {
    state.influencers.unshift(
      ...influencer_id_array.filter((e) => !state.influencers.includes(e))
    )
  },
  REMOVE_INFLUENCER_ARRAY: function (state, influencer_id_array) {
    Vue.set(
      state,
      "influencers",
      state.influencers.filter((e) => {
        return !influencer_id_array.includes(e)
      })
    )
  },
  ...resetMixin.mutations,
}

export const actions = {
  RESET: function ({ commit, dispatch }) {
    commit("RESET", initialState())
    dispatch("track/RESET")
  },
  SET_MESSAGES: function ({ commit, state }, message_object) {
    return new Promise((resolve, reject) => {
      this.$axios
        .$post("/submission/draft/message/", {
          messages: message_object,
          draft: state.id,
        })
        .then(({ messages }) => {
          commit("SET", { messages })
          resolve(messages)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  SET: function ({ commit, dispatch }, draft) {
    return new Promise(async (resolve, reject) => {
      const { track, promo } = draft

      if (track !== null) {
        if (typeof track === "object") commit("track/UPDATE", track)
        else if (typeof track === "number") await dispatch("track/FETCH", track)
      } else dispatch("track/RESET")
      commit("SET", draft)
      if (promo !== null) commit("promo/SET", promo)
      resolve(true)
    })
  },
  FETCH_BY_ID: function ({ commit }, id) {
    return new Promise((resolve, reject) => {
      if (!id) reject()
      else
        this.$axios
          .$get(`/submission/draft/${id}/`, {
            headers: { "X-CSRFToken": this.$cookies.get("csrftoken") },
          })
          .then((draft) => {
            resolve({ ...draft })
          })
          .catch((err) => {
            reject(err)
          })
    })
  },
  GET_CURRENT: async function ({ dispatch, state }, config) {
    config = config ?? {}

    const { clean_hidden_influencers } = config

    return new Promise((resolve, reject) => {
      if (!state.id || clean_hidden_influencers === true) {
        const url =
          "/submission/draft/current/" +
          (clean_hidden_influencers === true
            ? "?clean_hidden_influencers=true"
            : "")

        this.$axios
          .$get(url, {
            headers: { "X-CSRFToken": this.$cookies.get("csrftoken") },
          })
          .then(async (draft) => {
            await dispatch("SET", { ...draft })
            resolve(draft)
          })
          .catch((err) => {
            resolve({ ...state })
          })
      } else resolve({ ...state })
    })
  },
  RESET_CURRENT: async function ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .$delete("/submission/draft/current/", {
          headers: { "X-CSRFToken": this.$cookies.get("csrftoken") },
        })
        .then(() => {
          dispatch("RESET")
          resolve(true)
        })
        .catch(() => {
          resolve(true)
        })
    })
  },
  SET_CURRENT: async function ({ dispatch }, draft_id) {
    return new Promise((resolve, reject) => {
      this.$axios
        .$post(
          "/submission/draft/current/",
          {
            current_draft: draft_id,
          },
          {
            headers: { "X-CSRFToken": this.$cookies.get("csrftoken") },
          }
        )
        .then(async (draft) => {
          await dispatch("SET", draft)
          resolve({ ...draft })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  CREATE: function ({ dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .$post(
          "/submission/draft/",
          {
            band: rootState.user.band.id,
            influencers: rootState.cart.influencer_ids,
          },
          {
            headers: { "X-CSRFToken": this.$cookies.get("csrftoken") },
          }
        )
        .then((response) => {
          dispatch("SET_CURRENT", response.id)
            .then(async () => {
              dispatch("cart/DELETE", null, { root: true }), resolve(response)
            })
            .catch((err) => {
              reject(err)
            })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  UNBIND_TRACK: function ({ dispatch }) {
    return dispatch("UPDATE_SERVER", {
      track: null,
    })
  },
  BIND_TRACK: function ({ dispatch }, track_id) {
    return new Promise((resolve, reject) => {
      dispatch("track/FETCH", track_id)
        .then(() => {
          dispatch("UPDATE")
            .then((response) => {
              resolve(response)
            })
            .catch((err) => {
              reject(err)
            })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  UPDATE_SERVER: function ({ getters, state, dispatch }, patch) {
    return new Promise((resolve, reject) => {
      this.$axios
        .$patch(`/submission/draft/${state.id}/`, {
          ...getters.PATCH_DATA,
          ...(patch ?? {}),
        })
        .then((resp) => {
          resolve(dispatch("SET", patch))
        })
        .catch((err) => {
          console.log({ err })
          reject(err)
        })
    })
  },
  UPDATE: function ({ dispatch, getters }, patch) {
    patch = patch ?? { ...getters.PATCH_DATA }
    return dispatch("UPDATE_SERVER", patch)
  },
  DELETE: function (state, id) {
    return new Promise((resolve, reject) => {
      this.$axios
        .$delete(`/submission/draft/${id || state.id}/`)
        .then((resp) => {
          resolve(true)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  FETCH_MISSING_INFLUENCERS: function ({ dispatch, getters }) {
    return new Promise((resolve, reject) => {
      if (getters.MISSING_INFLUENCERS.length) {
        dispatch("influencers/FETCH_SET", getters.MISSING_INFLUENCERS, {
          root: true,
        })
          .then(() => {
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      } else resolve(true)
    })
  },
}

export const getters = {
  PATCH_DATA: function (state, getters) {
    return {
      ...state,
      influencers: state.influencers.length ? state.influencers : undefined,
      messages: getters.MESSAGES.length ? getters.MESSAGES : undefined,
      promo: state.promo?.id || undefined,
      track: state.track.id,
    }
  },
  MESSAGES: function (state) {
    return state.influencers.reduce(function (accumulator, element) {
      accumulator[element] = state.messages[element]?.length
        ? state.messages[element]
        : null
      return accumulator
    }, {})
  },
  MISSING_INFLUENCERS: function (state, getters, rootState, rootGetters) {
    return state.influencers.filter((influencer_id) => {
      return !rootGetters["influencers/ID_EXISTS"](influencer_id)
    })
  },
}
